import { render, staticRenderFns } from "./SelectUserTagsController.vue?vue&type=template&id=8450efc0&"
import script from "./SelectUserTagsController.vue?vue&type=script&lang=ts&"
export * from "./SelectUserTagsController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports